import { Box } from '@mui/material';
import { type FC, type MouseEvent } from 'react';
import { CommonIcon } from '../common/CommonIcon';

interface ActionCardDeleteButtonProps {
  onRemove: () => void;
  extraRemoveCount?: number;
}

export const ActionCardDeleteButton: FC<ActionCardDeleteButtonProps> = ({
  onRemove,
  extraRemoveCount = 0,
}) => (
  <Box sx={{ position: 'relative', flexShrink: 0 }}>
    <Box
      component="button"
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onRemove();
      }}
      sx={{
        background: 'color-mix(in srgb, var(--tg-theme-destructive-text-color) 7%, transparent)',
        border: '1px solid color-mix(in srgb, var(--tg-theme-destructive-text-color) 20%, transparent)',
        color: 'var(--tg-theme-destructive-text-color)',
        borderRadius: '9px',
        width: 30,
        height: 30,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CommonIcon icon="delete" type="outlined" size={16} color="var(--tg-theme-destructive-text-color)" />
    </Box>
    {extraRemoveCount > 0 && (
      <Box
        component="span"
        aria-hidden
        sx={{
          position: 'absolute',
          top: -6,
          right: -6,
          minWidth: 18,
          height: 16,
          px: 0.35,
          borderRadius: '8px',
          bgcolor: 'var(--tg-theme-destructive-text-color)',
          color: '#fff',
          fontSize: 9,
          fontWeight: 700,
          lineHeight: '16px',
          textAlign: 'center',
          pointerEvents: 'none',
          boxShadow: '0 1px 3px rgba(0,0,0,0.35)',
        }}
      >
        +{extraRemoveCount}
      </Box>
    )}
  </Box>
);
